import { ICON__heart_solid, ICON__trash_solid } from '@/assets/icons_fa';
import { use_dispatch } from '@/hooks/_base/use_dispatch';
import { use_slice_collections, use_slice_grid2d, use_slice_user, use_slice_workspace } from '@/hooks/store/use_slices';
import { HOOK_GRID2D_CELL__button_size } from '@/pages/_base/grid2d_cell/_hooks/HOOK_GRID2D_CELL__button_size';
import { REMOTE__collection_cells_delete } from '@/state/collection/cell/REMOTE__collection_cells_delete';
import { LOCAL__grid2d_cells_delete } from '@/state/grid2d/grid2d_cell/LOCAL__grid2d_cells_delete';
import { EVENT_NULL__mouse } from '@/types/types';
import { assert_array_not_empty } from '@shared/asserts/utils_asserts';
import { DTO__entity_with_grid2d } from '@shared/dto/+workspace/workspace_entity/_database_entity_with_grid2d_permissions/DTO__entity_with_grid2d';
import { ENUM__grid2d_feature } from '@shared/dto/+workspace/workspace_entity/_enums/ENUM__grid2d_feature';
import { ENUM__workspace_entity_feature } from '@shared/dto/+workspace/workspace_entity/_enums/ENUM__workspace_entity_feature';
import { DTO_REQUEST__collection_image_delete } from '@shared/dto/collection/_requests/DTO_REQUEST__collection_image_delete';
import { DTO__grid2d_cell } from '@shared/dto/grid2d_cell/DTO__grid2d_cell';
import { ENUM__grid2d_cell_size } from '@shared/dto/grid2d_cell/ENUM__grid2d_cell_size';
import { useState } from 'react';
import { UI_PRIMITIVE__button_with_icon_animated } from '../../../../components/ui/UI_PRIMITIVE__button_with_icon_animated';
import { UI_PRIMITIVE__tooltip } from '../../../../components/ui/UI_PRIMITIVE__tooltip';
import { HOOK_GRID2D_CELL__image_in_collection_current } from '../_hooks/HOOK_GRID2D_CELL__image_in_collection_current';

interface Props {
  cell: DTO__grid2d_cell;
  entity: DTO__entity_with_grid2d;
  wrapper_class_name: string;
}

export function BUTTON_GRID2D_IMAGE__collection_image_delete({ cell, wrapper_class_name, entity }: Props) {
  const dispatch = use_dispatch();

  const { current_workspace_user } = use_slice_workspace(['current_workspace_user']);
  const { user_settings } = use_slice_user(['user_settings']);
  const { collection_current } = use_slice_collections(['collection_current']);
  const { grids2d_map } = use_slice_grid2d(['grids2d_map']);

  /*
   *
   */

  const is_in_collection_current = HOOK_GRID2D_CELL__image_in_collection_current(cell);

  const grid2d_cell_button_size = HOOK_GRID2D_CELL__button_size(user_settings.ui_grid2d_cell_size);

  const [is_loading, set_is_loading] = useState(false);

  /*
   * EVENTS
   */
  async function onClick(e: EVENT_NULL__mouse) {
    e?.stopPropagation();

    /*
     *
     */

    let grid2d = grids2d_map.get_or_assert(collection_current._id);
    let cells = grid2d.cells__get_loaded();
    let cells_to_delete = cells.filter(item => item.hash_sha256_content == cell.hash_sha256_content);

    assert_array_not_empty(cells_to_delete);

    dispatch(LOCAL__grid2d_cells_delete(cells_to_delete));

    /*
     *
     */

    let request = new DTO_REQUEST__collection_image_delete();
    request.hash_sha256_content = cell.hash_sha256_content;
    request.collection_id = collection_current._id;

    set_is_loading(true);

    await dispatch(REMOTE__collection_cells_delete([request]));

    set_is_loading(false);
  }

  function get_icon() {
    return entity._id == collection_current._id ? ICON__trash_solid : ICON__heart_solid;
  }
  /*
   * RENDERS
   */

  /*
   * HTML
   */

  if (!is_in_collection_current) return null;
  //
  if (collection_current.is_stub()) return null;
  if (!collection_current.is_grid2d_feature_possible(ENUM__grid2d_feature.IMAGE_INTERNAL__DELETE)) return null; //action is not allowed on this grid2d
  //
  if (!current_workspace_user.is_feature_pertmitted(ENUM__workspace_entity_feature.ENTITY_COLLECTION_UPDATE)) return null; //action is not allowed for this user

  return (
    <div className={wrapper_class_name}>
      <UI_PRIMITIVE__tooltip tooltip_title={'Remove'}>
        <UI_PRIMITIVE__button_with_icon_animated
          variant="no-border-on-component"
          {...{ onClick }}
          className={`cursor-pointer  rounded-lg  p-0 bg-bar 
              ${grid2d_cell_button_size}`}
          disabled={is_loading}
          Icon={get_icon()}
          iconClassNameHovered="!text-bar-foreground"
          iconClassNameBase={`!text-component-item-foreground !duration-300 !w-4 !h-4
              ${user_settings.ui_grid2d_cell_size === ENUM__grid2d_cell_size.L ? '!size-7' : ''}`}
        />
      </UI_PRIMITIVE__tooltip>
    </div>
  );
}
